<main class="profile-page">
  <section class="section-profile-cover section-shaped my-0">
    <!-- Circles background -->
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <!-- SVG separator -->
    <div class="separator separator-bottom separator-skew">
      <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>
  </section>
  <section class="section">
    <div class="container">
      <div class="card card-profile shadow mt--300">
        <div class="px-5" style="padding-bottom:50px;">
          <div class="" style="margin-top:15vh">
            <h5 style="display: inline;">發布時間:2020.12.09</h5><h5 style="display: inline; float:right">類別:<a href="#">技術開發</a></h5>
            <h1 style="font-weight: bold;">程式開發者成功的祕訣</h1>
            <div class="justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="news-pic">
                  <a href="javascript:void(0)">
                    <img src="./assets/img/theme/news_1.jpg" class="">
                  </a>
                </div>
              </div>
            </div>
            <div class="h6 font-weight-300"><i class="ni location_pin mr-8"></i>
              <h4 style="font-weight: bold;">原碼開發的強力助手-Spring Boot</h4></div>
            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-8"></i>
              我們是使用Spring Boot來開發，他能夠讓我們程式的架構更穩定，流程更為順暢，使客戶在使用我們開發的產品時更方便，且更不容易出錯。</div>
          </div>
          <div class="mt-5 py-5">
              <h4 style="font-weight: bold;">那什麼是Spring Boot呢?</h4>
            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-8"></i>
              Spring Boot是由Pivotal團隊在2013年開始研發、2014年4月發布第一個版本。所以它是一個新型的框架。它基於Spring4.0設計，不僅繼承了Spring框架原有的優秀特性，而且還通過簡化配置來進一步簡化了Spring應用的整個搭建和開發過程。另外Spring Boot通過集成大量的框架使得依賴包的版本沖突，以及引用的不穩定性等問題得到了很好的解決。
              然而說到Spring Boot，很多人會想到Spring 和Spring MVC。究竟它們有什麼差別?<br />
              第一，Spring是一種框架，包含一系列的IoC容器的設計和依賴注入(DI)及整合AOP功能。<br />
              第二，Spring Boot 和 Spring MVC 都是一種框架，同時它們的核心是Spring。<br />
              第三，Spring Boot包含了Spring MVC，同時能簡化配置。<br />
            </div>
            <h4 style="font-weight: bold;">我們選擇使用Spring Boot開發的原因是：</h4>
            <ul>
              <li>Spring Boot有很好的程式基礎架構，可以提高開發者的開發速度，使工作更有效率</li>
              <li>開箱即用（啟動器starter-其實就是SpringBoot提供的一個jar包），但通過自己設定引數（.properties），即可快速擺脫這種方式。</li>
              <li>提供了一些大型專案中常見的非功能性特性，如內嵌伺服器、安全、指標，健康檢測、外部化配置等</li>
              <li>絕對沒有程式碼生成，也無需 XML 配置。</li>
            </ul>
              Spring Boot將會是未來開發程式的主流架構，其穩定性跟方便性是現今市面上各軟體架構難以比擬的，若有開發的需求必然需要跟上時代的腳步，當然要選擇最方便又快速的Spring Boot。
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
